import { Box } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const AppLogo = ({ height = 48, sx = {} }) => {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const logoSrc = isArabic ? "/Logo_ar.png" : "/Logo_en.png";
  const alt = isArabic ? "خدمة العملاء" : "Customer Care";

  return (
    <Box
      component="img"
      src={logoSrc}
      alt={alt}
      sx={{
        height,
        width: "auto",
        maxWidth: "100%",
        objectFit: "contain",
        display: "block",
        ...sx,
      }}
    />
  );
};

export default AppLogo;
